var _classCallCheck = require("/Users/me/Work/PublicRec-main/website/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/Users/me/Work/PublicRec-main/website/node_modules/@babel/runtime/helpers/createClass.js");

var countries = require('country-list/data.json');

var countryAlts = require('./country-alts.json');

var provinces = require('provinces/provinces.json'); // Map additional data and conform data to standard format


var countryData = countries.map(function (val) {
  return Object.assign({
    alt: countryAlts[val.code]
  }, val);
});
var provinceData = provinces.map(function (val) {
  return {
    name: val.name,
    code: val.short,
    countryCode: val.country,
    alt: val.alt,
    region: val.region
  };
}); // Helper functions

var compareExact = function compareExact(word1, word2) {
  return word1 !== undefined && word2 !== undefined && word1.toLowerCase() === word2.toLowerCase();
};

var alternateNameSearch = function alternateNameSearch(word, words) {
  return word !== undefined && words !== undefined && words.find(function (val) {
    return val.toLowerCase() === word.toLowerCase();
  }) !== undefined;
}; // Classes


var Countries = /*#__PURE__*/function () {
  "use strict";

  function Countries() {
    _classCallCheck(this, Countries);
  }

  _createClass(Countries, null, [{
    key: "data",
    get: function get() {
      return countryData;
    }
  }, {
    key: "byName",
    value: function byName(name) {
      return new Country(this.data.find(function (val) {
        return compareExact(name, val.name) || alternateNameSearch(name, val.alt);
      }));
    }
  }, {
    key: "byCode",
    value: function byCode(code) {
      return new Country(this.data.find(function (val) {
        return compareExact(code, val.code);
      }));
    }
  }]);

  return Countries;
}();

var Provinces = /*#__PURE__*/function () {
  "use strict";

  function Provinces(countryCode) {
    _classCallCheck(this, Provinces);

    this.data = Provinces.data.filter(function (val) {
      return compareExact(countryCode, val.countryCode);
    });
    this.countryCode = countryCode;
  }

  _createClass(Provinces, [{
    key: "byName",
    value: function byName(name) {
      return new Province(this.data.find(function (val) {
        return compareExact(name, val.name) || alternateNameSearch(name, val.alt);
      }));
    }
  }, {
    key: "byCode",
    value: function byCode(code) {
      return new Province(this.data.find(function (val) {
        return compareExact(code, val.code);
      }));
    }
  }, {
    key: "byNameOrCode",
    value: function byNameOrCode(nameOrCode) {
      return new Province(this.data.find(function (val) {
        return compareExact(nameOrCode, val.name) || alternateNameSearch(nameOrCode, val.alt) || compareExact(nameOrCode, val.code);
      }));
    }
  }], [{
    key: "data",
    get: function get() {
      return provinceData;
    }
  }, {
    key: "byName",
    value: function byName(name) {
      return new Province(this.data.find(function (val) {
        return compareExact(name, val.name) || alternateNameSearch(name, val.alt);
      }));
    }
  }, {
    key: "byCode",
    value: function byCode(code) {
      return new Province(this.data.find(function (val) {
        return compareExact(code, val.code);
      }));
    }
  }, {
    key: "byCountryCode",
    value: function byCountryCode(countryCode) {
      return this.data.filter(function (val) {
        return compareExact(countryCode, val.countryCode);
      }).map(function (val) {
        return new Province(val);
      });
    }
  }]);

  return Provinces;
}();

var Country = /*#__PURE__*/function () {
  "use strict";

  function Country(nameOrCode) {
    _classCallCheck(this, Country);

    this.name;
    this.code;
    this.alt;

    if (typeof nameOrCode === 'string') {
      var result = Countries.data.find(function (val) {
        return compareExact(nameOrCode, val.name) || alternateNameSearch(nameOrCode, val.alt) || compareExact(nameOrCode, val.code);
      });
      Object.assign(this, result);
    } else {
      Object.assign(this, nameOrCode);
    }

    if (this.code) {
      this.provinces = new Provinces(this.code);
    }
  }

  _createClass(Country, [{
    key: "provinceByName",
    value: function provinceByName(name) {
      return this.provinces.byName(name);
    }
  }, {
    key: "provinceByCode",
    value: function provinceByCode(code) {
      return this.provinces.byCode(code);
    }
  }, {
    key: "provinceByNameOrCode",
    value: function provinceByNameOrCode(nameOrCode) {
      return this.provinces.byNameOrCode(nameOrCode);
    }
  }]);

  return Country;
}();

var Province = /*#__PURE__*/_createClass(function Province(nameOrCode) {
  "use strict";

  _classCallCheck(this, Province);

  this.name;
  this.code;
  this.countryCode;
  this.alt;
  this.region;

  if (typeof nameOrCode === 'string') {
    var result = Provinces.data.find(function (val) {
      return compareExact(nameOrCode, val.name) || alternateNameSearch(nameOrCode, val.alt) || compareExact(nameOrCode, val.code);
    });
    Object.assign(this, result);
  } else {
    Object.assign(this, nameOrCode);
  }

  if (this.countryCode) {
    this.country = Countries.byCode(this.countryCode);
  }
});

module.exports = {
  Countries: Countries,
  Provinces: Provinces,
  Country: Country,
  Province: Province
};